<template>
  <div class="task-status-badge text-capitalize" :class="statusClasses">
    {{ status }}
  </div>
</template>

<script>
const COMPLETED = 'completed';
const PENDING = 'pending';
const ONGOING = 'on-going';

export default {
  props: {
    status: {
      required: true,
      type: String,
    },
  },

  computed: {
    statusClasses () {
      return {
        success: this.status === COMPLETED,
        warning: this.status === ONGOING,
        secondary: this.status === PENDING,
      };
    },
  },
};
</script>

<style scoped lang="scss">
.task-status-badge {
  color: #fff;
  width: 80px;
  font-family: "Open Sans", sans-serif;
  font-size: 10px;
  font-weight: bold;
  letter-spacing: 0;
  line-height: 24px;
  padding: 2px 12px;
  border-radius: 5px;
  text-align: center;

  &.success {
    background-color: #2ecc71;
  }

  &.warning {
    background-color: #fb8c00;
  }

  &.secondary {
    background-color: #c2c2c2;
  }
}
</style>
